import { NgClass } from '@angular/common';
import { Component, ComponentRef, Input, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';

import { ModalRef } from './modal-ref';
import { ModalCloseData } from './modal.interface';

@Component({
    selector: 'trg-modal',
    templateUrl: './modal.component.html',
    standalone: true,
    imports: [NgClass],
})
export class ModalComponent implements OnDestroy {
    componentRef: ComponentRef<any>;
    standAlone: boolean = false;
    @Input() closeActive: boolean = true;
    @Input() backdropClickActive: boolean = true;
    @Input() title: string = null;

    @ViewChild('insertionComp', { read: ViewContainerRef, static: true }) insertionComp: ViewContainerRef;

    @Input('modalSize') modalSize: string = '';

    constructor(private modalRef: ModalRef<any>) {}

    ngOnDestroy(): void {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    closeClicked(data: ModalCloseData = { crossClicked: true }) {
        this.modalRef.close(data);
    }

    backdropClicked() {
        if (this.backdropClickActive) {
            this.closeClicked({ backdropClicked: true });
        }
    }
}
